import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
export default class IgnoreUserModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.user = this.attrs.user;
    this.ignoreLevel = this.user.ignoreLevel() || 0;
  }
  className() {
    return 'IgnoreUserModal Modal--small';
  }
  title() {
    return app.translator.trans('bizkaitarra-ignore-users.forum.ignore_modal.title', {
      username: this.user.username()
    });
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('bizkaitarra-ignore-users.forum.ignore_modal.label')), m("div", {
      className: "helpText"
    }, app.translator.trans('bizkaitarra-ignore-users.forum.ignore_modal.help_text')), m("div", {
      className: "IgnoreUserModal-options"
    }, m("div", {
      className: "Form-group"
    }, m("label", {
      className: "checkbox"
    }, m("input", {
      type: "radio",
      name: "ignoreLevel",
      checked: this.ignoreLevel === 0,
      onchange: () => this.ignoreLevel = 0
    }), app.translator.trans('bizkaitarra-ignore-users.forum.ignore_modal.level_partial'), m("div", {
      className: "helpText"
    }, app.translator.trans('bizkaitarra-ignore-users.forum.ignore_modal.level_partial_help')))), m("div", {
      className: "Form-group"
    }, m("label", {
      className: "checkbox"
    }, m("input", {
      type: "radio",
      name: "ignoreLevel",
      checked: this.ignoreLevel === 1,
      onchange: () => this.ignoreLevel = 1
    }), app.translator.trans('bizkaitarra-ignore-users.forum.ignore_modal.level_total'), m("div", {
      className: "helpText"
    }, app.translator.trans('bizkaitarra-ignore-users.forum.ignore_modal.level_total_help')))))), m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      type: "submit",
      loading: this.loading
    }, app.translator.trans('bizkaitarra-ignore-users.forum.ignore_modal.submit_button'))));
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    this.user.save({
      ignored: true,
      ignoreLevel: this.ignoreLevel
    }).then(() => {
      this.hide();
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('bizkaitarra-ignore-users.forum.ignore_modal.success_message'));
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('bizkaitarra-ignore-users', 'forum/components/IgnoreUserModal', IgnoreUserModal);